module.exports = __webpack_public_path__ + "static/media/mp.be962d7e.svg";